<template>
  <div id="app" v-bind:class="{'withNav':(showNav === true)}">
    <transition name="fade" mode="out-in">
    <Nav v-if="showNav"></Nav>
    </transition>
    <transition name="fade" mode="out-in">
    <SideNav v-if="showNav"></SideNav>
    </transition>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>

<script>
import { mapState } from "vuex";
import Nav from "@/components/Nav";
import SideNav from "@/components/SideNav";

export default {
  components: {
    SideNav,
    Nav,
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      return Object.keys(this.userProfile).length > 1;
    },
  },
};
</script>
